'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'MunicipalityRestService',
    function ($modal, MunicipalityRestService) {

        return {
            edit: edit,
            create: create,
            api: MunicipalityRestService
        };

        function create() {
            return $modal.open({
                template: require('../view/municipality-modal-create.html'),
                controller: 'MunicipalityModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    municipality: function () {
                        return {};
                    }
                }
            });
        }

        function edit(item) {
            return $modal.open({
                template: require('../view/municipality-modal-create.html'),
                controller: 'MunicipalityModalCreateController',
                controllerAs: 'vm',
                backdrop: false,
                size: 'md',
                resolve: {
                    municipality: function () {
                        return item;
                    }
                }
            });
        }

    }];